import "./OfficialChannels.scss";
import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

const OfficialChannels = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="section-head">
          <h2 className="section-title">지온나래/학교 공식 채널</h2>
          <p className="section-desc">
            영상·글·현장 소식을 가장 빠르게 확인할 수 있어요.
          </p>
        </div>

        <div className="channel-grid">
          <a
            className="channel-card"
            href="https://www.instagram.com/gist_gionnarae/"
            target="_blank"
            rel="noreferrer"
          >
            <span className="channel-badge instagram">Instagram</span>
            <h3 className="channel-title">지온나래 Instagram</h3>
            <p className="channel-desc">
              지온나래가 직접 전하는 캠퍼스 일상과 유용한 정보 채널입니다. 신입생과 재학생 모두에게 도움이 되는 친근한 콘텐츠를 만나보세요.
            </p>
            <div className="channel-link">바로 가기 <FaArrowRight /></div>
          </a>

          <a
            className="channel-card"
            href="https://m.blog.naver.com/PostList.naver?blogId=bestgista&tab=1"
            target="_blank"
            rel="noreferrer"
          >
            <span className="channel-badge blog">Blog</span>
            <h3 className="channel-title">GIST 블로그 (네이버)</h3>
            <p className="channel-desc">
              GIST의 캠퍼스 소식과 행사, 학사 정보 등을 가장 빠르게 만나볼 수 있는 공식 블로그입니다. 학교의 다양한 이야기를 사진과 함께 생생하게 전달합니다.
            </p>
            <div className="channel-link">바로 가기 <FaArrowRight /></div>
          </a>

          <a
            className="channel-card"
            href="https://www.youtube.com/c/GIST_YOUTUBE"
            target="_blank"
            rel="noreferrer"
          >
            <span className="channel-badge youtube">YouTube</span>
            <h3 className="channel-title">GIST 공식 YouTube</h3>
            <p className="channel-desc">
              GIST의 연구 성과, 캠퍼스 브이로그, 학교 소개 영상을 한눈에 볼 수 있는 공식 채널입니다. 영상으로 더 생생하게 GIST를 경험해보세요.
            </p>
            <div className="channel-link">바로 가기 <FaArrowRight /></div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default OfficialChannels;